import React from 'react';
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact';
import { withUserContext } from '../../../contexts/UserContext';
import { handlePaginationList } from '../../../Common/TableHelper';
import NotificationComponent from '../../../Common/NotificationComponent/NotificationComponent';
import * as Constants from '../../../constants/constants';
import ClearTrackService from '../../../services/service';
import { Tree } from 'react-arborist';
import BasicButton from '../../SharedComponents/BasicButton/BasicButton';
import BasicTextField from '../../SharedComponents/BasicTextField/BasicTextField';
import SelectField from '../../SharedComponents/SelectField/SelectField';
import BasicCheckbox from '../../SharedComponents/BasicCheckbox/BasicCheckbox';
import { rightsRecordJson, defaultTreeViewRightsFilters, applyTreeViewRightsFiltersToPayload } from '../ShowSeasonDetails/config';
import { IoMdArrowDropright, IoMdCloudDownload, IoMdCloudDone } from 'react-icons/io';
import './TreeView.scss';
import { Collapse, CircularProgress } from '@material-ui/core';
import TableComponent from '../../SharedComponents/Table';
const TREE_VIEW_LICENSOR_TYPE_OPTIONS = [
    { value: 'S', label: 'S' },
    { value: 'M', label: 'M' },
    { value: 'SM', label: 'SM' },
    { value: 'G', label: 'G' }
];

const TREE_VIEW_FILTER_ROWS = [
    { key: 'usingSongsOnly', label: 'Using songs only' },
    { key: 'completedEpsOnly', label: 'Completed eps only' },
    { key: 'coaOnly', label: 'COA only' },
    { key: 'excludeCoa', label: 'Exclude COA' },
    { key: 'includeInterior', label: 'Include episodic clearance' },
    { key: 'includeMainTitle', label: 'Include main title' },
    { key: 'whvCmpltOnly', label: 'WHV complete only' },
    { key: 'msCmpltOnly', label: 'MS complete only' },
    { key: 'limitMusicCost', label: 'Limit by music cost (> 0)' },
    { key: 'libraryOnly', label: 'Library only' },
    { key: 'excludeLibrary', label: 'Exclude library' },
    { key: 'excludePromo', label: 'Exclude promo' }
];
export default withUserContext(class TreeViewComponent extends React.Component {
    treeRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            showSeasonId: props?.showSeasonId,
            showSeasonEpisodeId: props?.showSeasonEpisodeId,
            showId: props?.showId,
            seasonId: props?.seasonId,
            seasonName: props?.seasonName?.season_name,
            showName: props?.showName,
            cueSheetDetails: {} , // JSON.parse(JSON.stringify({ ...initialCueSheetConfig })),
            cueSheetHeaderDetails: {} , //JSON.parse(JSON.stringify({ ...initialCueSheetHeaderConfig })),
            showSeasonEpisodeCueSheetRecords: {},
            isFetchingCueSheetDetails: false,
            isFetchingTreeViewDetails: false,
            expanded: false,
            setExpanded: false,
            renderList: [],
            config: {} , //JSON.parse(JSON.stringify({ ...cueSheetConfig })),
            showRecurringModal: false,
            compositions: [],
            showEditDetailsPopup: false,
            page: 0,
            rowsPerPage: 250,
            selectedAiring: null,
            selectedRecurringSong: null,
            cueSheetRecordData: null,
            airingList: [],
            headingsData: null,
            isSubmit: false,
            showSeasonComposerModal: false,
            composerOptions:[],
            selectedComposer: null,
            composerDetalis: [],
            approveStatus : false,
            rejectedStatus: false,
            compositionOption:[],
            recurringList:[],
            isPreviewLoader: false,
            showImportCueSheet:false,
            divisionData: null,
            currentUser: null,
            index: null,
            treeData: []
            , focusId: null
            ,selectedNodeId : null,
            immediateChildrenCount: null, 
            totalGrandChildrenCount: null,
            expandedIds: [],
            selectedIds: [],
            licenseCount: 0,
            songCount: 0,
            feeSum : 0,
            selectedSong: null,
            selectedLicense: null,
            selectedProgram: null,
            selectedSeason: null,
            selectedEpisode: null,
            selectedRight: null, 
            nodeMetaData: null,       
            searchTerm: "",
            searchResults: [],
            currentIndex: -1,
            initialOpen: { },
            displayAllShows: false,
            /** `season` = Season → Show → … ; `program` = Program (Show) → Season → … */
            treeGroupBy: 'season',
            treeFilters: { ...defaultTreeViewRightsFilters },
            treeFiltersPanelOpen: false,
            isExportingTreePdf: false
        }
    };

    
    componentDidMount() {
        this.getTreeViewDetails(this.props?.showId, this.props?.seasonId);
    }

    componentDidUpdate(prevProps) {
        if (
            this.props?.showId !== null &&
            this.props?.seasonId !== null &&
            (prevProps?.showId !== this.props?.showId || prevProps?.seasonId !== this.props?.seasonId)
        ) {
            this.getTreeViewDetails(this.props?.showId, this.props?.seasonId);
        }
    }

    /**
     * Same body as `dashboardRights` for this screen — shared by tree fetch and PDF export.
     */
    buildDashboardRightsQueryPayload = (showId, seasonId) => {
        let mockJSON = { ...rightsRecordJson };
        const resolvedShowId = showId || this.props?.showId || this.state?.show_id || null;
        const resolvedSeasonId = seasonId ?? this.props?.seasonId ?? this.state?.season_id ?? null;
        this._treeFetchContext = { showId: resolvedShowId, seasonId: resolvedSeasonId };
        mockJSON.all_seasons = this.state.displayAllShows;
        mockJSON.pagination = false;
        /*
         * usp_dashboard_rights_get: when all_seasons=1, show/season filters are not applied to temp;
         * result set 1 is then narrowed by tree_detail_show_id / season_id IN var_season_search_ids.
         * When all_seasons=0 and tree_group_by=program with show set + season null → program_scope=1 (all seasons of that show in temp).
         */
        mockJSON.tree_group_by = this.state.treeGroupBy === 'program' ? 'program' : 'season';
        mockJSON.tree_detail_show_id = null;
        mockJSON.tree_detail_season_id = null;

        if (this.state.treeGroupBy === 'program') {
            if (this.state.displayAllShows) {
                mockJSON.show_search_ids = null;
                mockJSON.season_search_ids = null;
                mockJSON.tree_detail_show_id = resolvedShowId != null ? String(resolvedShowId) : null;
            } else {
                mockJSON.show_search_ids = resolvedShowId != null ? String(resolvedShowId) : null;
                mockJSON.season_search_ids = null;
            }
        } else {
            if (this.state.displayAllShows) {
                mockJSON.show_search_ids = null;
                mockJSON.season_search_ids = seasonId ?? this.props?.seasonId ?? this.state?.season_id ?? null;
            } else {
                mockJSON.show_search_ids = resolvedShowId != null ? String(resolvedShowId) : null;
                mockJSON.season_search_ids = resolvedSeasonId != null ? String(resolvedSeasonId) : null;
            }
        }
        applyTreeViewRightsFiltersToPayload(mockJSON, this.state.treeFilters);
        return mockJSON;
    };

    getTreeViewDetails = (showId, seasonId) => {

        let path = 'dashboardRights';
        // Start refresh state for all tree fetches
        this.setState({ isFetchingTreeViewDetails: true });

        const mockJSON = this.buildDashboardRightsQueryPayload(showId, seasonId);
       ClearTrackService.getDataParams(Constants.ClearTrackServiceBaseUrl + `/${path}`, mockJSON,
                       this.props?.userContext?.active_tenant?.tenant_id)
                       .then(response => {
                            let clearenceRecordsList = response?.data.treeData || [];
                            let mappedData = response?.data?.mappedData || {};
                            // Ensure clearenceRecordsList is always an array
                            if (!Array.isArray(clearenceRecordsList)) {
                                clearenceRecordsList = clearenceRecordsList ? Object.values(clearenceRecordsList) : [];
                            }
                    const initialOpen = {};
                    Object.values(mappedData).forEach(node => {
                        if ((node.metadata?.level ?? 0) <= 2) initialOpen[node.id] = true;
                        else initialOpen[node.id] = false;
                    });
                    const autoSelectId = this.getAutoSelectNodeId(mappedData);
                    if (autoSelectId) {
                        this.applyOpenStateForPath(initialOpen, autoSelectId);
                    }
                    const ctx = this._treeFetchContext || {};

                           this.setState({
                               clearancePage:0,
                               clearenceRecordsList: handlePaginationList(0, this.state.clearancerowsPerPage, clearenceRecordsList?.clearance_records),
                               backUpclearenceRecordsList: clearenceRecordsList?.clearance_records,
                               isFetchingTreeViewDetails: false,
                               selectedNodeId: autoSelectId || null,
                               focusId: autoSelectId || null,
                               nodeMetaData: null,
                               show_id: clearenceRecordsList?.show_id ?? ctx.showId ?? this.state.show_id,
                               season_id: clearenceRecordsList?.season_id ?? ctx.seasonId ?? this.state.season_id,
                               show_name: clearenceRecordsList?.show_name,
                               season_name: clearenceRecordsList?.season_name,
                               episode_name: clearenceRecordsList?.episode_title,
                               episode_number: clearenceRecordsList?.episode_number,
                               division_id: clearenceRecordsList?.division_id,
                               show_season_time :  clearenceRecordsList?.show_season_time,
                               air_date : clearenceRecordsList?.air_date,
                               clearance_rep: clearenceRecordsList?.clearance_rep,
                               main_title_song : clearenceRecordsList?.main_title_song,
                               total_initial_fees : clearenceRecordsList?.total_initial_fees,
                               productionEnity : clearenceRecordsList?.company,
                               treeData : clearenceRecordsList,
                               mappedData: mappedData,
                               initialOpen: initialOpen
                           }, () => {
                            if (autoSelectId) {
                                this.calculateStats(autoSelectId);
                            }
                           });
                       },
                           (err) => {
                               console.error('TreeView dashboardRights fetch failed:', err);
                               this.setState({ isFetchingTreeViewDetails: false });
                           })
    }

    refreshRootSeason = (node) => {
        if (this.state.isFetchingTreeViewDetails) return;
        
        let seasonName = node?.data?.name || null;
        this.openNodesUpToLevel(1, node?.data?.id);
        const meta = node?.data?.metadata;
        const nodeType = meta?.type;
        const propSeason = this.props?.seasonId || this.state?.season_id;
        this.setState({ isFetchingTreeViewDetails: true, seasonName: seasonName }, () => {
            if (nodeType === 'season') {
                this.getTreeViewDetails(null, meta.m_id);
            } else if (nodeType === 'show') {
                this.getTreeViewDetails(
                    meta.m_id,
                    this.state.treeGroupBy === 'program' ? null : (this.state.displayAllShows ? null : propSeason)
                );
            } else {
                this.getTreeViewDetails(this.props?.showId || this.state?.show_id, propSeason);
            }
        });
    }

    toggleDisplayAllShows = () => {
        const newDisplayAllShows = !this.state.displayAllShows;
        this.setState({ displayAllShows: newDisplayAllShows }, () => {
            // Reload tree data with new setting
            const showId = !newDisplayAllShows? this.props?.showId || this.state?.showId : null;
            const seasonId = !newDisplayAllShows? this.props?.seasonId || this.state?.seasonId : null;
            this.getTreeViewDetails(showId, seasonId);
        });
    }

    setTreeGroupBy = (value) => {
        const treeGroupBy = value === 'program' ? 'program' : 'season';
        if (treeGroupBy === this.state.treeGroupBy) return;
        this.setState({ treeGroupBy }, () => {
            if (this.state.displayAllShows) {
                this.getTreeViewDetails(null, null);
            } else {
                this.getTreeViewDetails(this.props?.showId || this.state?.show_id, this.props?.seasonId || this.state?.season_id);
            }
        });
    }

    downloadTreePdfUrl = (url) => {
        if (!url) return;
        const clean = String(url).replace(/^"|"$/g, '').trim();
        if (!clean.startsWith('http://') && !clean.startsWith('https://')) return;
        const link = document.createElement('a');
        link.href = clean;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    exportTreeViewPdf = () => {
        const ctx = this._treeFetchContext || {};
        const showId = ctx.showId ?? this.props?.showId ?? this.state?.show_id ?? null;
        const seasonId = ctx.seasonId ?? this.props?.seasonId ?? this.state?.season_id ?? null;
        const payload = this.buildDashboardRightsQueryPayload(showId, seasonId);
        Object.keys(payload).forEach((k) => {
            if (payload[k] === undefined) payload[k] = null;
        });
        this.setState({ isExportingTreePdf: true });
        const encryptTedStr = btoa(JSON.stringify(payload));
        const load = {
            payload: 'exportPdf',
            reportName: 'rptTreeViewReport',
            fileName: 'TreeViewReport',
            searchJson: encryptTedStr,
            showHtml: 0,
            encryptionType: 1,
            tenantId: this.props?.userContext?.active_tenant?.tenant_id,
            divisionId: this.props.division_id,
        };
        ClearTrackService.getDataWS(load)
            .then((webSocketConn) => {
                webSocketConn.onmessage = (e) => {
                    let response;
                    try {
                        response = JSON.parse(e.data);
                    } catch (err) {
                        this.setState({ isExportingTreePdf: false });
                        return;
                    }
                    this.setState({ isExportingTreePdf: false });
                    if (response?.statusCode !== 200) {
                        this.setState({ openNotification: 'error', anyErrorMessage: 'Report export failed.' });
                        return;
                    }
                    const raw = response?.body;
                    if (raw === 'NODATA' || raw === '"NODATA"' || (typeof raw === 'string' && raw.includes('NODATA'))) {
                        this.setState({ openNotification: 'error', anyErrorMessage: 'No data found for this report.' });
                        return;
                    }
                    let url = raw;
                    if (typeof raw === 'string') {
                        try {
                            const parsed = JSON.parse(raw);
                            if (parsed?.error) {
                                this.setState({
                                    openNotification: 'error',
                                    anyErrorMessage: parsed.message || 'Report failed.',
                                });
                                return;
                            }
                            if (typeof parsed === 'string') url = parsed;
                            else if (Array.isArray(parsed) && parsed[0]?.rptTreeViewReport) url = parsed[0].rptTreeViewReport;
                        } catch (_) {
                            /* body is plain URL */
                        }
                    }
                    this.downloadTreePdfUrl(url);
                };
            })
            .catch(() => {
                this.setState({
                    isExportingTreePdf: false,
                    openNotification: 'error',
                    anyErrorMessage: 'Report export failed.',
                });
            });
    };

findNodeById(nodeId) {
    if (!this.state.mappedData) return null;
    return this.state.mappedData[nodeId];
}

applyOpenStateForPath(openMap, nodePathId) {
    if (!nodePathId || !openMap) return;
    const parts = nodePathId.split('/');
    for (let i = 1; i <= parts.length; i++) {
        openMap[parts.slice(0, i).join('/')] = true;
    }
}

/**
 * After load/refresh: select the tree root for the scope that was just loaded.
 * Season grouping → root is `s-{seasonId}`; then show child if needed.
 * Program grouping → root is `sh-{showId}`; then season child if needed.
 * Uses _treeFetchContext from the active getTreeViewDetails call so display-all + drill-in matches API scope.
 */
getAutoSelectNodeId(mappedData) {
    if (!mappedData || typeof mappedData !== 'object') return null;
    const ctx = this._treeFetchContext || {};
    const showId = ctx.showId ?? this.props?.showId ?? this.state?.show_id ?? null;
    const seasonId = ctx.seasonId ?? this.props?.seasonId ?? this.state?.season_id ?? null;
    const treeGroupBy = this.state.treeGroupBy;

    if (treeGroupBy === 'season') {
        if (seasonId != null) {
            const seasonRoot = `s-${seasonId}`;
            if (mappedData[seasonRoot]) return seasonRoot;
            if (showId != null) {
                const showUnderSeason = `s-${seasonId}/sh-${showId}`;
                if (mappedData[showUnderSeason]) return showUnderSeason;
            }
        }
        if (showId != null) {
            for (const node of Object.values(mappedData)) {
                const m = node?.metadata;
                if (m?.type === 'show' && String(m.m_id) === String(showId)) return node.id;
            }
        }
        return null;
    }

    if (showId != null) {
        const showRoot = `sh-${showId}`;
        if (mappedData[showRoot]) return showRoot;
        if (seasonId != null) {
            const seasonUnderShow = `sh-${showId}/s-${seasonId}`;
            if (mappedData[seasonUnderShow]) return seasonUnderShow;
        }
    }
    if (seasonId != null) {
        for (const node of Object.values(mappedData)) {
            const m = node?.metadata;
            if (m?.type === 'season' && String(m.m_id) === String(seasonId)) return node.id;
        }
    }
    return null;
}

handleNodeSelect = (element) => {
    if (element.isSelected) {
      this.setState({ focusId: element.element.id, selectedNodeId: element.element.id }, () => {
        this.calculateStats(element.element.id);
      });
    } else {
      this.setState({ focusId: null, selectedNodeId: null });
    }
};


calculateStats(nodeId) {
      if (!nodeId || !this.state.mappedData) return;

    const node = this.findNodeById(nodeId);
    if (!node) return;

    if (node.metadata) {
        const path = nodeId.split("/");
        const mappedData = this.state.mappedData;
        const isSingleSeason = node.metadata?.type === 'season' && node.metadata?.level === 1 && !this.state.displayAllShows;
        const licenseCount = isSingleSeason ? (node.metadata?.ssLicenseCount || 0) : (node.metadata?.licenseCount || 0);
        const songCount    = isSingleSeason ? (node.metadata?.ssSongCount    || 0) : (node.metadata?.songCount    || 0);
        const feeSum       = isSingleSeason ? (node.metadata?.ssFeeSum       || 0) : (node.metadata?.feeSum       || 0);
        const activeNodeMeta = isSingleSeason ? {
            ...node.metadata,
            initialRightsMap:    node.metadata.ssInitialRightsMap    || {},
            altInitialMap:       node.metadata.ssAltInitialMap       || {},
            optionAcquiredMap:   node.metadata.ssOptionAcquiredMap   || {},
            optionNotAcquiredMap: node.metadata.ssOptionNotAcquiredMap || {}
        } : node.metadata;
        let season = "";
        let show = "";
        let episode = "";
        let composition = "";
        let licensor = "";
        let right = "";
        let currentPath = "";
        for (let i = 0; i < path.length; i++) {
            currentPath = currentPath + (i === 0 ? "" : "/") + path[i];
            const seg = mappedData[currentPath];
            const t = seg?.metadata?.type;
            if (!t) continue;
            if (t === 'season') season = seg.name;
            else if (t === 'show') show = seg.name;
            else if (t === 'episode') episode = seg.name;
            else if (t === 'song') composition = seg.name;
            else if (t === 'type') right = seg.name;
            else if (t === 'licensor') licensor = seg.name;
        }

        this.setState({ selectedSeason: season, selectedProgram: show, selectedEpisode: episode, selectedSong: composition, selectedLicensor: licensor, selectedRight: right, licenseCount: licenseCount, songCount: songCount, feeSum: feeSum, nodeMetaData: activeNodeMeta });
    }
}

// Virtualized tree row renderer (react-arborist)
CustomTreeNode = ({ node, style }) => {
  const isRootNode = node.data?.metadata?.level === 1;
  return (
    <div 
      style={style} 
      className={`node-row ${node.isSelected ? "selected" : ""}`}
      onClick={() => node.select()}
    >
      <div className="node-content" style={{ paddingLeft: node.level * 20, display: 'flex', alignItems: 'center' }}>
        {/* Toggle Arrow */}
        <span className="arrow-container">
          {!node.isLeaf && (
            <span 
              onClick={(e) => { e.stopPropagation(); node.toggle(); }}
              style={{ display: 'inline-flex', transform: node.isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}
            >
              <IoMdArrowDropright size={22} />
            </span>
          )}
        </span>

        {/* Node Name with Ellipsis for 65k performance */}
        <span className="node-name-wrap">
          <span className="node-name" title={node.data.name}>{node.data.name}</span>
          {node.data.metadata?.isMT && <span className="mt-badge" title="Main Title">MT</span>}
        </span>

        {isRootNode && (
          <button
            className="root-refresh-btn"
            onClick={(e) => {
              e.stopPropagation();
              this.refreshRootSeason(node);
            }}
            title={this.state.treeGroupBy === 'program' ? 'Refresh program data' : 'Refresh season data'}
            style={{ marginLeft: 'auto', border: 'none', background: 'transparent', cursor: 'pointer', flexShrink: 0 }}
          >
            {this.state.isFetchingTreeViewDetails && node?.data?.name === this.state.seasonName ? (
              <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 22, height: 22 }}>
                <CircularProgress size={18} />
              </span>
            ) : node.data.metadata?.isPartial ? (
              <IoMdCloudDownload size={22} />
            ) : (
              <IoMdCloudDone size={22} color="green" />
            )}
          </button>
        )}

      </div>
    </div>
  );
};

closeAllNodes = () => {
    this.treeRef.current.closeAll();
};
openNodesUpToLevel = (targetLevel, levelNode = null) => {
    let tree = this.treeRef.current;
    let nodesMap = this.state.mappedData || {};
    const newOpenState = {};
    tree.closeAll();
    Object.values(nodesMap).forEach(node => {
        if(!levelNode){
            if (node.metadata?.level < targetLevel && node.children ) {
                newOpenState[node.id] = true;
            }
        }
        else {
            if(node.id === levelNode || node.id.startsWith(levelNode+"/")){
                newOpenState[node.id] = true;
            }
        }
    });
    Object.keys(newOpenState).forEach(id => tree.open(id));
    this.setState({initialOpen: newOpenState});
};

 onSearchSubmit = (e) => {
    e.preventDefault();

    let nodesMap = this.state.mappedData || {};
    let searchTerm = this.state.searchTerm.trim().toLowerCase();
    const matches = Object.values(nodesMap)
    .filter(n => n.name.toLowerCase().includes(searchTerm))
    .map(n => n.id);

    if (matches.length > 0) {
        this.setState({ searchResults: matches, currentIndex: 0 }, () => {
            this.navigateToMatch(0);
        });
    } else {
        this.setState({ searchResults: [], currentIndex: -1 });
    }

  };

  navigateToMatch = (index) => {
    const { searchResults } = this.state;
    const tree = this.treeRef.current;
    const nodeId = searchResults[index];

    if (nodeId && tree) {
        // 1. Expand all folders leading to this node
        tree.openParents(nodeId);

        // 2. Selection and Scrolling (with slight delay for virtualization calc)
        setTimeout(() => {
            tree.select(nodeId);
            tree.scrollTo(nodeId, "start"); // "smart" centers it if possible
            
            // 3. Update Side Detail Panel
            const nodeData = this.state.mappedData[nodeId];
            this.handleNodeSelect({ isSelected: true, element: nodeData });
        }, 50);
    }
  };

  handleNext = () => {
    const nextIndex = (this.state.currentIndex + 1) % this.state.searchResults.length;
    this.setState({ currentIndex: nextIndex }, () => this.navigateToMatch(nextIndex));
};

  handlePrev = () => {
    const prevIndex = (this.state.currentIndex - 1 + this.state.searchResults.length) % this.state.searchResults.length;
    this.setState({ currentIndex: prevIndex }, () => this.navigateToMatch(prevIndex));
};
    render() {
        if (!Array.isArray(this.state.treeData)) {
            console.error("CRITICAL: treeData is not an array!", this.state.treeData);
            return null; // Prevent crash
        }
        return (
            <>
            <NotificationComponent
                open={this.state.openNotification?.length > 0 ? true : false}
                message={this.state.anyErrorMessage ? this.state.anyErrorMessage  : this.state.openNotification === 'success' ? 'Changes saved sucessfully' : this.state.openNotification === 'error' ? 'Saving Changes failed' : ''}
                severity={this.state.openNotification || ''}
                handleResetNotify={() => this.setState({ openNotification: null ,anyErrorMessage : null})}
            />
            <div className="cuesheet row" id='mainGrid'>
                    <div id="episode-clearance-treeview-table">
                    <MDBRow className="tree-view-split-row">
                    <MDBCol className="tree-view-col" size='6'>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'column'}}>
                        <div className="tree-controls" style={{ width: '100%', display: 'block', justifyContent: 'center', marginBottom: '10px' }}>
                        <div className="tree-view-group-by-row">
                            <SelectField
                                id="tree-group-by"
                                label="Group by"
                                width="200px"
                                value={this.state.treeGroupBy}
                                options={[
                                    { value: 'season', label: 'Season' },
                                    { value: 'program', label: 'Program' }
                                ]}
                                onChange={(e) => this.setTreeGroupBy(e.target.value)}
                                disabled={this.state.isFetchingTreeViewDetails}
                                defaultMenuText="Group by"
                            />
                        <BasicButton
                                icon={this.state.displayAllShows ? "check" : "x"} 
                                text={this.state.displayAllShows ? "Limit By Show" : "Clear"}
                                variant={!this.state.displayAllShows ? "contained" : "outlined"}
                                iconRight={true} 
                                disabled={this.state.isFetchingTreeViewDetails} 
                                onClick={() => this.toggleDisplayAllShows()} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'left', marginBottom: '5px', flexWrap: 'wrap', gap: '5px' }}>
                            <BasicButton
                                icon={"collapse"} text="Collapse All"
                                variant="outlined" iconRight={true} disabled={this.state.isFetchingTreeViewDetails} onClick={() => this.openNodesUpToLevel(1)} />
                            <BasicButton
                                icon={"season"} text={this.state.treeGroupBy === 'program' ? "View Shows" : "View Seasons"}
                                variant="outlined" iconRight={true} disabled={this.state.isFetchingTreeViewDetails} onClick={() => this.openNodesUpToLevel(1)} />
                            <BasicButton
                                icon={"show"} text={this.state.treeGroupBy === 'program' ? "View Seasons" : "View Shows"}
                                variant="outlined" iconRight={true} disabled={this.state.isFetchingTreeViewDetails} onClick={() => this.openNodesUpToLevel(2)} />
                            <BasicButton
                                icon={"episode"} text="View Episodes"
                                variant="outlined" iconRight={true} disabled={this.state.isFetchingTreeViewDetails} onClick={() => this.openNodesUpToLevel(3)} />
                            <BasicButton
                                icon={"song"} text="View Songs"
                                variant="outlined" iconRight={true} disabled={this.state.isFetchingTreeViewDetails} onClick={() => this.openNodesUpToLevel(4)} />
                            <BasicButton
                                icon={"licensor"} text="View Licensors"
                                variant="outlined" iconRight={true} disabled={this.state.isFetchingTreeViewDetails} onClick={() => this.openNodesUpToLevel(6)} />
                            <BasicButton
                                icon={"file-alt"}
                                text="Export tree report (PDF)"
                                variant="outlined"
                                iconRight={true}
                                disabled={this.state.isFetchingTreeViewDetails || this.state.isExportingTreePdf}
                                onClick={this.exportTreeViewPdf}
                            />
                        </div>
                        <div className="tree-view-search-row">
                            <div className="tree-view-search-field">
                                <BasicTextField
                                    id="tree-search"
                                    placeholder="Search Season, Episode, or Licensor..."
                                    value={this.state.searchTerm}
                                    onChange={(e) => this.setState({ searchTerm: e.target.value })}
                                    disabled={this.state.isFetchingTreeViewDetails}
                                    width="100%"
                                />
                            </div>
                            <BasicButton
                                type="inline"
                                text="Find"
                                variant="outlined"
                                onClick={this.onSearchSubmit}
                                disabled={this.state.isFetchingTreeViewDetails}
                            />
                            {this.state.searchResults.length > 0 && (
                                <div className="tree-view-search-nav">
                                    <BasicButton
                                        type="inline"
                                        text="↑ Prev"
                                        variant="outlined"
                                        onClick={this.handlePrev}
                                        disabled={this.state.isFetchingTreeViewDetails}
                                    />
                                    <span className="tree-view-search-nav-count">
                                        {this.state.currentIndex + 1} of {this.state.searchResults.length}
                                    </span>
                                    <BasicButton
                                        type="inline"
                                        text="↓ Next"
                                        variant="outlined"
                                        onClick={this.handleNext}
                                        disabled={this.state.isFetchingTreeViewDetails}
                                    />
                                </div>
                            )}
                        </div>
                        <div className="tree-view-filters-wrap">
                            <BasicButton
                                type="inline"
                                text={this.state.treeFiltersPanelOpen ? 'Hide filters' : 'Filter by'}
                                variant="outlined"
                                onClick={() => this.setState({ treeFiltersPanelOpen: !this.state.treeFiltersPanelOpen })}
                                disabled={this.state.isFetchingTreeViewDetails}
                            />
                            <Collapse in={this.state.treeFiltersPanelOpen}>
                                <div className="tree-view-filter-panel">
                                    <div className="tree-view-filter-licensor-type">
                                        <SelectField
                                            id="tree-filter-licensor-type"
                                            label="Licensor type"
                                            width="200px"
                                            value={this.state.treeFilters.licensorType || ''}
                                            options={TREE_VIEW_LICENSOR_TYPE_OPTIONS}
                                            onChange={(e) =>
                                                this.setState({
                                                    treeFilters: {
                                                        ...this.state.treeFilters,
                                                        licensorType: e.target.value || ''
                                                    }
                                                })
                                            }
                                            disabled={this.state.isFetchingTreeViewDetails}
                                            defaultMenuText="All types (no filter)"
                                        />
                                    </div>
                                    <div className="tree-view-filter-grid">
                                        {TREE_VIEW_FILTER_ROWS.map((row) => (
                                            <BasicCheckbox
                                                key={row.key}
                                                id={`tree-filter-${row.key}`}
                                                label={row.label}
                                                checked={!!this.state.treeFilters[row.key]}
                                                disabled={this.state.isFetchingTreeViewDetails}
                                                onChange={(e) =>
                                                    this.setState({
                                                        treeFilters: {
                                                            ...this.state.treeFilters,
                                                            [row.key]: e.target.checked,
                                                        },
                                                    })
                                                }
                                            />
                                        ))}
                                    </div>
                                    <div className="tree-view-filter-actions">
                                        <BasicButton
                                            type="inline"
                                            text="Apply filters"
                                            variant="contained"
                                            onClick={() =>
                                                this.getTreeViewDetails(
                                                    this.props?.showId || this.state?.show_id,
                                                    this.props?.seasonId || this.state?.season_id
                                                )
                                            }
                                            disabled={this.state.isFetchingTreeViewDetails}
                                        />
                                        <BasicButton
                                            type="inline"
                                            text="Reset"
                                            variant="outlined"
                                            onClick={() =>
                                                this.setState(
                                                    { treeFilters: { ...defaultTreeViewRightsFilters } },
                                                    () =>
                                                        this.getTreeViewDetails(
                                                            this.props?.showId || this.state?.show_id,
                                                            this.props?.seasonId || this.state?.season_id
                                                        )
                                                )
                                            }
                                            disabled={this.state.isFetchingTreeViewDetails}
                                        />
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                        </div>
                        {this.state.isFetchingTreeViewDetails && (
                            <div className="tree-loading-indicator" style={{ padding: 10, color: '#0056b3', background: '#eaf1ff', borderRadius: 4, marginBottom: 10 }}>
                                {this.state.displayAllShows ? 'Refreshing tree data (All ' + (this.state.treeGroupBy === 'program' ? 'Programs' : 'Seasons') + ')' : `Refreshing tree data (${this.state.treeGroupBy === 'program' ? 'Program' : 'Season'}): ${this.state.treeGroupBy === 'program' ? this.state.showName || '...' : this.state.seasonName || '...'}`}
                            </div>
                        )}
                        <MDBContainer fluid style={{ position: 'relative', height: '600px', display: 'flex', 
                            justifyContent: 'center', alignItems: 'center', backgroundColor: '#fefefe' }}>
                            <Tree ref={this.treeRef}
                                data={this.state.treeData} // Your 65,000 nodes
                                // initialOpenState={this.state.initialOpen}
                                openState={this.state.initialOpen}
                                selection={this.state.selectedNodeId || undefined}
                                width="100%"
                                height={600}           // Container height
                                rowHeight={28}         // FIXED height for virtualization math
                                indent={20}
                                childrenKey="children" 
                                onSelect={(nodes) => {
                                    // Prevent selection and operations if fetching
                                    if (this.state.isFetchingTreeViewDetails) {
                                        return;
                                    }
                                    if (nodes.length > 0) {
                                    // Map the arborist event back to your existing handleNodeSelect
                                    this.handleNodeSelect({
                                        isSelected: true,
                                        element: nodes[0].data
                                    });
                                    }
                                }}
                                >
                                {this.CustomTreeNode}
                                </Tree>
                            {/* Loading Overlay */}
                            {this.state.isFetchingTreeViewDetails && (
                              <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 1000,
                                borderRadius: 4,
                                backdropFilter: 'blur(1px)'
                              }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                                  <CircularProgress
                                    size={56}
                                    thickness={4}
                                    className="tree-view-loading-spinner"
                                  />
                                  <div style={{ color: 'white', fontSize: 16, fontWeight: 500 }}>Loading...</div>
                                </div>
                              </div>
                            )}
                          </MDBContainer>

                          
                        </div>
                    
                    </MDBCol>
                    <MDBCol className="tree-view-col tree-view-summary-col" size='6'>
                        <div className="tree-view-summary-panel">
                         {/* Move the selected node info to the top right */}
                         {this.state.selectedNodeId  && <div
                          className='selected-node-info'
                        >
                        
                            {this.state.selectedNodeId ? (
                                <>                                             
                                <div className="tree-view-summary-heading">Selection summary</div>
                                <ul className="tree-view-summary-list">
                                    {this.state.selectedSeason && 
                                        <li key={`season-${this.state.selectedSeason}`} className="tree-view-summary-row">
                                            <span className="tree-view-summary-label">Season</span>
                                            <span className="tree-view-summary-value">{this.state.selectedSeason}</span>
                                        </li>                     
                                    } 
                                    {this.state.selectedProgram && 
                                        <li key={`program-${this.state.selectedProgram}`} className="tree-view-summary-row">
                                            <span className="tree-view-summary-label">Show</span>
                                            <span className="tree-view-summary-value">{this.state.selectedProgram}</span>
                                        </li>                     
                                    }  
                                    {this.state.selectedEpisode && 
                                        <li key={`episode-${this.state.selectedEpisode}`} className="tree-view-summary-row">
                                            <span className="tree-view-summary-label">Episode</span>
                                            <span className="tree-view-summary-value">{this.state.selectedEpisode}</span>
                                        </li>                     
                                    }  
                                    {this.state.selectedSong && 
                                        <li key={`song-${this.state.selectedSong}`} className="tree-view-summary-row">
                                            <span className="tree-view-summary-label">Song</span>
                                            <span className="tree-view-summary-value">{this.state.selectedSong}</span>
                                        </li>                     
                                    }               
                                    <li key={`songCnt-${this.state.selectedSong}`} className="tree-view-summary-row tree-view-summary-row--stat">
                                        <span className="tree-view-summary-label">Songs#</span>
                                        <span className="tree-view-summary-value tree-view-summary-value--accent">{this.state.songCount}</span>
                                    </li>
                                    <li key={`licenseCnt-${this.state.selectedSong}`} className="tree-view-summary-row tree-view-summary-row--stat">
                                        <span className="tree-view-summary-label">Licenses#</span>
                                        <span className="tree-view-summary-value tree-view-summary-value--accent">{this.state.licenseCount}</span>
                                    </li>  
                                    <li key={`feeSum-${this.state.selectedSong}`} className="tree-view-summary-row tree-view-summary-row--stat tree-view-summary-row--fee">
                                        <span className="tree-view-summary-label">Tot Init Fee#</span>
                                        <span className="tree-view-summary-value tree-view-summary-value--fee">{this.state.feeSum ? `$${Number(this.state.feeSum).toLocaleString()}` : 'N/A'}</span>
                                    </li>                                 
                                </ul>
                               
                                </>
                            ) : (
                                <p className="tree-view-summary-placeholder"></p>
                            )}
                                </div>
                            }

                        {this.state.treeData && <div className="tree-view-rights-tables">
                        
                          {this.state.nodeMetaData && 
                          <>
                          <div className="tree-view-rights-block">
                            <div className="tree-view-rights-title">
                              <span className="tree-rights-title-text">Initial Rights</span>
                              <span className="tree-rights-title-count">{this.state.nodeMetaData.initialRightsMap ? Object.keys(this.state.nodeMetaData.initialRightsMap).length : 0}</span>
                            </div>
                            <div className="tree-rights-table">
                              <TableComponent
                                list={
                                  this.state.nodeMetaData.initialRightsMap && Object.keys(this.state.nodeMetaData.initialRightsMap).length > 0
                                    ? Object.entries(this.state.nodeMetaData.initialRightsMap).map(([right, fee]) => ({ right, fee: `$${Number(fee).toLocaleString()}` }))
                                    : []
                                }
                                config={{
                                  headings: [
                                    { headingLabel: 'Rights', inputType: 'text', width: '70' },
                                    { headingLabel: 'Fee', inputType: 'text', width: '30' },
                                  ],
                                  dataNodes: ['right', 'fee'],
                                  primaryKey: 'right',
                                }}
                                className="rightsInitial"
                                tableMode="light"
                                stickyHeader={false}
                              />
                            </div>
                          </div>
                          <div className="tree-view-rights-block">
                            <div className="tree-view-rights-title">
                              <span className="tree-rights-title-text">Alt. Init. Rights</span>
                              <span className="tree-rights-title-count">{this.state.nodeMetaData.altInitialMap ? Object.keys(this.state.nodeMetaData.altInitialMap).length : 0}</span>
                            </div>
                            <div className="tree-rights-table">
                              <TableComponent
                                list={
                                  this.state.nodeMetaData.altInitialMap && Object.keys(this.state.nodeMetaData.altInitialMap).length > 0
                                    ? Object.entries(this.state.nodeMetaData.altInitialMap).map(([right, fee]) => ({ right, fee: `$${Number(fee).toLocaleString()}` }))
                                    : []
                                }
                                config={{
                                  headings: [
                                    { headingLabel: 'Rights', inputType: 'text', width: '70' },
                                    { headingLabel: 'Fee', inputType: 'text', width: '30' },
                                  ],
                                  dataNodes: ['right', 'fee'],
                                  primaryKey: 'right',
                                }}
                                className="rightsAltInit"
                                tableMode="light"
                                stickyHeader={false}
                              />
                            </div>
                          </div>
                          <div className="tree-view-rights-block">
                            <div className="tree-view-rights-title">
                              <span className="tree-rights-title-text">Options (NOT Acquired)</span>
                              <span className="tree-rights-title-count">{this.state.nodeMetaData.optionAcquiredMap ? Object.keys(this.state.nodeMetaData.optionAcquiredMap).length : 0}</span>
                            </div>
                            <div className="tree-rights-table">
                              <TableComponent
                                list={
                                  this.state.nodeMetaData.optionAcquiredMap && Object.keys(this.state.nodeMetaData.optionAcquiredMap).length > 0
                                    ? Object.entries(this.state.nodeMetaData.optionAcquiredMap).map(([right, fee]) => ({ right, fee: `$${Number(fee).toLocaleString()}` }))
                                    : []
                                }
                                config={{
                                  headings: [
                                    { headingLabel: 'Rights', inputType: 'text', width: '70' },
                                    { headingLabel: 'Fee', inputType: 'text', width: '30' },
                                  ],
                                  dataNodes: ['right', 'fee'],
                                  primaryKey: 'right',
                                }}
                                className="rightsOptNotAcq"
                                tableMode="light"
                                stickyHeader={false}
                              />
                            </div>
                          </div>
                          <div className="tree-view-rights-block">
                            <div className="tree-view-rights-title">
                              <span className="tree-rights-title-text">Options (Acquired)</span>
                              <span className="tree-rights-title-count">{this.state.nodeMetaData.optionNotAcquiredMap ? Object.keys(this.state.nodeMetaData.optionNotAcquiredMap).length : 0}</span>
                            </div>
                            <div className="tree-rights-table">
                              <TableComponent
                                list={
                                  this.state.nodeMetaData.optionNotAcquiredMap && Object.keys(this.state.nodeMetaData.optionNotAcquiredMap).length > 0
                                    ? Object.entries(this.state.nodeMetaData.optionNotAcquiredMap).map(([right, fee]) => ({ right, fee: `$${Number(fee).toLocaleString()}` }))
                                    : []
                                }
                                config={{
                                  headings: [
                                    { headingLabel: 'Rights', inputType: 'text', width: '70' },
                                    { headingLabel: 'Fee', inputType: 'text', width: '30' },
                                  ],
                                  dataNodes: ['right', 'fee'],
                                  primaryKey: 'right',
                                }}
                                className="rightsOptAcq"
                                tableMode="light"
                                stickyHeader={false}
                              />
                            </div>
                          </div>
                          </>
                        }

                        </div>    
                        }
                        </div>
                    </MDBCol>
                       
                    </MDBRow>
                </div>
            </div>
            </>
        );
    }
});

